<template>
  <div>
    <h2 class="ViewHeading">Remedial Actions</h2>
    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col>
          <b-card-group deck
            ><b-card
              border-variant="info"
              header="New Actions"
              header-bg-variant="info"
              align="center"
            >
              <b-card-text>You have {{ ActionsNew }} New Action(s)</b-card-text>
              <b-card-text></b-card-text> </b-card
            ><b-card
              border-variant="warning"
              header="Actions Due"
              header-bg-variant="warning"
              align="center"
            >
              <b-card-text
                >You have {{ ActionsDue }} Action(s) that have a deadline in the
                next 28 days</b-card-text
              >
            </b-card>
            <b-card
              border-variant="danger"
              header="Overdue Actions"
              header-bg-variant="danger"
              align="center"
            >
              <b-card-text
                >You have {{ ActionsOverdue }} Action(s) that has passed
                completion deadline</b-card-text
              >
              <b-card-text></b-card-text>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-row><br /></b-row>
    </div>
    <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Open Actions Status" active>
            <div id="Table">
              <br />
              <h4>Tracked Actions</h4>
              <br />
              <div>
                <b-table
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="ActionStatusItems"
                  :fields="ActionStatusFields"
                  hover
                  small
                >
                  <template v-slot:cell(7)="{ item }">
                    <div v-if="item[7] === 'New'">
                      <b-badge variant="info">New</b-badge>
                    </div>
                    <div v-if="item[7] === 'Overdue'">
                      <b-badge variant="danger">Overdue</b-badge>
                    </div>
                    <div v-if="item[7] === 'Due'">
                      <b-badge variant="warning">Due</b-badge>
                    </div>
                    <div v-if="item[7] === 'In Progress'">
                      <b-badge variant="info">In Progress</b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(8)="{ item }">
                    <b-button
                      variant="outline-info"
                      size="sm"
                      v-on:click="showActionDetails(item)"
                      >Show</b-button
                    >
                  </template>
                </b-table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Completed Actions" lazy>
            <br />
            <h4 class="centered">Completed Actions</h4>
            <br />
            <div>
              <b-table
                sticky-header
                no-border-collapse
                responsive
                :items="items2"
                :fields="fields2"
                hover
                small
                show-empty
                empty-text="There are no completed actions for this location"
              >
                <template v-slot:cell(ActionStatus)="{ item }">
                  <div v-if="item.ActionStatus === 'Complete'">
                    <b-badge variant="info">Complete</b-badge>
                  </div>
                  <div v-if="item.ActionStatus === 'Late'">
                    <b-badge variant="danger">Late</b-badge>
                  </div>
                  <div v-if="item.ActionStatus === 'Due'">
                    <b-badge variant="warning">Due</b-badge>
                  </div>
                </template>
                <template v-slot:cell(Details)="{ item }">
                  <b-button
                    variant="outline-info"
                    size="sm"
                    v-b-modal.modal-10
                    v-on:click="dummymodal(item)"
                    >Details</b-button
                  >
                </template>
              </b-table>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-modal id="modal-10" title="Details">
        <b-card>
          <b-spinner
            type="grow"
            variant="info"
            style="width: 3rem; height: 3rem;"
            label="Loading..."
          ></b-spinner>
        </b-card>
      </b-modal>
      <b-modal id="modal-11" title="Modify">
        <b-card>
          <b-spinner
            type="grow"
            variant="info"
            style="width: 3rem; height: 3rem;"
            label="Loading..."
          ></b-spinner>
        </b-card>
      </b-modal>
      <b-modal
        ref="ServiceRequestModal"
        id="ServiceRequestModal"
        title="Action"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        ok-only
      >
        <RequestService> </RequestService>
      </b-modal>
      <b-modal
        ref="ActioningModal"
        id="ActioningModal"
        title="Action"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        hide-footer
      >
        <h5>Update Status</h5>
        <b-row>
          <b-col>
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio
                v-model="UpdateStatus"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="In Progress"
                >In Progress</b-form-radio
              >
              <b-form-radio
                v-model="UpdateStatus"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="Completed"
                >Completed</b-form-radio
              >
            </b-form-group>
          </b-col>
        </b-row>
        <section>
          <b-row>
            <b-col>
              <h5>Add Note</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-textarea v-model="CompletionNote" />
            </b-col>
          </b-row>
        </section>
        <br />
        <b-row>
          <b-col>
            <b-button v-on:click="updateActionStatus()" variant="outline-info">
              Submit
            </b-button>
          </b-col>
          <b-col>
            <b-button v-on:click="resetActionStatus()" variant="outline-info">
              Reset
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        ref="ActionModal"
        id="ActionModal"
        title="Action Management"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        ok-only
        v-model="modalShowing"
      >
        <b-card
          border-variant="dark"
          align="center"
          :header-bg-variant="this.ActionVariant"
          footer-tag="footer"
        >
          <template #header>
            <h4 class="#">
              Action ID: {{ PassActionID }} <br />
              <!-- Outlet ID:
              {{ PassOutletID }} -->
            </h4>
          </template>
          <b-card-sub-title class="mb-2"
            >Type: {{ PassActionType }}</b-card-sub-title
          >
          <b-row
            ><b-col
              ><h5>{{ this.PassActionDeadline }}</h5></b-col
            ><b-col
              ><h5>{{ this.PassResponsibility }}</h5></b-col
            ></b-row
          >
          <b-row
            ><b-col>Desc: {{ this.PassDesc }}</b-col></b-row
          >

          <b-row
            ><b-col>Linked Risk Assessment ID:</b-col
            ><b-col> {{ this.PassLinkAssessment }}</b-col></b-row
          >
          <br />
          <b-card>
            {{ this.PassNote }}
          </b-card>
          <br />
          <b-button-group>
            <b-button v-on:click="ActionTheAction()" variant="outline-info">
              Action
            </b-button>

            <b-button
              v-on:click="DownloadAssessment(PassLinkAssessment)"
              variant="outline-info"
            >
              View Linked Document
            </b-button>

            <b-button
              v-on:click="RequestService(PassActionID)"
              variant="outline-info"
            >
              Request Service
            </b-button>
          </b-button-group>
        </b-card>
      </b-modal>
      <b-modal
        size="xl"
        header-bg-variant="dark"
        header-text-variant="light"
        ref="ColonyDetail"
        id="ColonyDetail"
        :title="'Test ' + modalItem[0]"
      >
        <b-card :header-bg-variant="OverallColour">
          <template #header> Test Result - {{ ColonyDetails[7] }} </template>
          <b-row>
            <b-col><label class="boldLabel">Test Type</label></b-col>
            <b-col><label class="boldLabel">Outlet Details</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[0] }}</b-col>
            <b-col>{{
              this.ColonyDetails[3] + " - " + this.ColonyDetails[4]
            }}</b-col>
          </b-row>
          <hr />
          <section
            v-if="
              (this.ColonyDetails[0] == 'Legionella' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 0) &
                (this.ColonyDetails[8] == 'For Review')
            "
          >
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Legionella cfu/1000ml MW28</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Legionella pneumophila SG 1 cfu/1000 ml MW28</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[12] }}</b-col>
              <b-col>{{ this.ColonyDetails[13] }}</b-col>
            </b-row>

            <br />
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Legionella pneumophila SG 2-14 cfu/1000 ml MW28</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Legionella species non pneumophila cfu/1000 ml MW28</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[14] }}</b-col>
              <b-col>{{ this.ColonyDetails[15] }}</b-col>
            </b-row>
            <br />
          </section>

          <!-- DO THE THING -->
          <section
            v-if="
              (this.ColonyDetails[0] == 'Legionella' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 1) &
                (this.ColonyDetails[8] == 'For Review')
            "
          >
            <b-row>
              <b-col><label class="boldLabel">Legionella MPN</label></b-col>
              <b-col><label class="boldLabel">Legionella Result</label></b-col>
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[12] }}</b-col>
              <b-col>{{ this.ColonyDetails[13] }}</b-col>
            </b-row>
          </section>
          <section
            v-if="
              (this.ColonyDetails[0] == 'Pseudomonas' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 0) &
                (this.ColonyDetails[8] == 'For Review')
            "
          >
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Aerobic Plate Count 37°C [2 days] cfu/ml MW3</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Aerobic Plate Count 22°C [3 days] cfu/ml MW3</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[16] }}</b-col>
              <b-col>{{ this.ColonyDetails[17] }}</b-col>
            </b-row>

            <br />
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Pseudomonas aeruginosa cfu/100 ml MW4</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Total Coliforms cfu/100 ml MW10</label
                ></b-col
              >
            </b-row>
            <b-row>
              <b-col>{{ this.ColonyDetails[18] }}</b-col>
              <b-col>{{ this.ColonyDetails[19] }}</b-col>
            </b-row>
            <br />
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Escherichia coli cfu/100 ml MW10</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Pseudomonas 30 °C cfu/ml MW32</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[20] }}</b-col>
              <b-col>{{ this.ColonyDetails[21] }}</b-col>
            </b-row>
          </section>
          <section
            v-if="
              (this.ColonyDetails[0] == 'Pseudomonas' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 1) &
                (this.ColonyDetails[8] == 'For Review')
            "
          >
            <b-row>
              <b-col><label class="boldLabel">Pseudomonas MPN</label></b-col>
              <b-col><label class="boldLabel">Pseudomonas Result</label></b-col>
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[14] }}</b-col>
              <b-col>{{ this.ColonyDetails[15] }}</b-col>
            </b-row>
          </section>

          <section
            v-if="
              (this.ColonyDetails[0] == 'Legionella' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 0) &
                (this.ColonyDetails[8] == 'Completed')
            "
          >
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Legionella cfu/1000ml MW28</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Legionella pneumophila SG 1 cfu/1000 ml MW28</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[12] }}</b-col>
              <b-col>{{ this.ColonyDetails[13] }}</b-col>
            </b-row>

            <br />
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Legionella pneumophila SG 2-14 cfu/1000 ml MW28</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Legionella species non pneumophila cfu/1000 ml MW28</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[14] }}</b-col>
              <b-col>{{ this.ColonyDetails[15] }}</b-col>
            </b-row>
            <br />
          </section>

          <section
            v-if="
              (this.ColonyDetails[0] == 'Legionella' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 1) &
                (this.ColonyDetails[8] == 'Completed')
            "
          >
            <b-row>
              <b-col><label class="boldLabel">Legionella MPN</label></b-col>
              <b-col><label class="boldLabel">Legionella Result</label></b-col>
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[12] }}</b-col>
              <b-col>{{ this.ColonyDetails[13] }}</b-col>
            </b-row>
          </section>
          <section
            v-if="
              (this.ColonyDetails[0] == 'Pseudomonas' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 0) &
                (this.ColonyDetails[8] == 'Completed')
            "
          >
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Aerobic Plate Count 37°C [2 days] cfu/ml MW3</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Aerobic Plate Count 22°C [3 days] cfu/ml MW3</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[16] }}</b-col>
              <b-col>{{ this.ColonyDetails[17] }}</b-col>
            </b-row>

            <br />
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Pseudomonas aeruginosa cfu/100 ml MW4</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Total Coliforms cfu/100 ml MW10</label
                ></b-col
              >
            </b-row>
            <b-row>
              <b-col>{{ this.ColonyDetails[18] }}</b-col>
              <b-col>{{ this.ColonyDetails[19] }}</b-col>
            </b-row>
            <br />
            <b-row>
              <b-col
                ><label class="boldLabel"
                  >Escherichia coli cfu/100 ml MW10</label
                ></b-col
              >
              <b-col
                ><label class="boldLabel"
                  >Pseudomonas 30 °C cfu/ml MW32</label
                ></b-col
              >
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[20] }}</b-col>
              <b-col>{{ this.ColonyDetails[21] }}</b-col>
            </b-row>
          </section>
          <section
            v-if="
              (this.ColonyDetails[0] == 'Pseudomonas' ||
                this.ColonyDetails[0] == 'Both') &
                (this.testingTabs == 1) &
                (this.ColonyDetails[8] == 'Completed')
            "
          >
            <b-row>
              <b-col><label class="boldLabel">Pseudomonas MPN</label></b-col>
              <b-col><label class="boldLabel">Pseudomonas Result</label></b-col>
            </b-row>

            <b-row>
              <b-col>{{ this.ColonyDetails[14] }}</b-col>
              <b-col>{{ this.ColonyDetails[15] }}</b-col>
            </b-row>
          </section>
          <!-- <b-spinner></b-spinner> -->
        </b-card>
      </b-modal>
      <section
        class="noshow"
        v-if="(this.doPDF == true) & (this.modalShowing == true)"
      >
        <PDF v-if="this.doPDF == true" :key="componentKey"> </PDF>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import PDF from "./PDFTemplate.vue";
import RequestService from "../components/ServiceClient.vue";
import { riskDirectDownloadByKey } from "@/Services/aws.js";

export default {
  computed: {},
  components: { PDF, RequestService },

  data() {
    return {
      ActionStatusItems: [],
      ActionStatusFields: [
        { key: "0", label: "Action ID", variant: "primary" },
        { key: "1", label: "Action Type" },
        { key: "2", label: "Description" },
        // { key: "3", label: "Outlet ID" },
        { key: "3", label: "Action Deadline" },
        // { key: "5", label: "Action Status" },
        { key: "4", label: "Action Responsibility" },
        { key: "5", label: "Linked ID" },

        // { key: "7", label: "Linked Risk Assessment" },
        { key: "6", label: "Action Note" },
        { key: "7", label: "Action Status" },
        { key: "8", label: "Details" },
      ],
      ActionsDue: "",
      ActionsNew: "",
      ActionsOverdue: "",
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      item: {},
      items2: [],
      fields2: [
        { key: "ActionID", label: "Action ID", variant: "primary" },
        { key: "ActionType", label: "Action Type" },
        { key: "Description", label: "Description" },
        { key: "OutletID", label: "Outlet ID" },
        { key: "CompletedDate", label: "Completed Date" },
        { key: "ActionResponsibillity", label: "Action Responsibillity" },
        { key: "LinkedRiskAssessment", label: "Linked ID" },
        { key: "ActionNote", label: "Action Note" },
      ],
      ActionVariant: "",
      PassActionID: "",
      PassOutletID: "",
      PassActionType: "",
      PassLinkAssessment: "",
      PassActionDeadline: "",
      PassResponsibility: "",
      PassNote: "",
      PassDesc: "",
      modalShowing: false,
      doPDF: false,
      UpdateStatus: "",
      CompletionNote: "",
      AssessmentType: "",
      LinkedRiskAssessment: this.$LinkedRisk,
      LinkedRiskLocation: this.$LinkedRiskLocation,
      ColonyDetails: [],
      modalItem: "",
      modalDetails: "",
      testingTabs: 0,
      LegionColour: "",
      PseudoColour: "",
      OverallColour: "",
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = {
      ServiceType: "RemedialActions",
      RequestType: "CompletedActions",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
      let itemsArray = response.data.Values;
      for (var i = 0; i < itemsArray.length; i++) {
        this.items2.push({
          ActionID: itemsArray[i][0],
          ActionType: itemsArray[i][1],
          Description: itemsArray[i][2],
          OutletID: itemsArray[i][3],
          CompletedDate: itemsArray[i][4],
          ActionResponsibillity: itemsArray[i][5],
          LinkedRiskAssessment: itemsArray[i][6],
          ActionNote: itemsArray[i][7],
        });
      }
    });

    let LookUpUrlActionCounts =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersActionCounts = this.$apikeyPost;
    let LookUpRequestActionCounts = {
      ServiceType: "RemedialActions",
      RequestType: "ActionCounts",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlActionCounts,
        LookUpRequestActionCounts,
        LookUpHeadersActionCounts
      )
      .then((response) => {
        this.ActionsDue = response.data.ActionsDueThirtyDays;
        this.ActionsNew = response.data.NewActions;
        this.ActionsOverdue = response.data.OverdueActions;
      });

    let LookUpUrlActionStatus =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersActionStatus = this.$apikeyPost;
    let LookUpRequestActionStatus = {
      ServiceType: "RemedialActions",
      RequestType: "ActionStatus",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlActionStatus,
        LookUpRequestActionStatus,
        LookUpHeadersActionStatus
      )
      .then((response) => {
        this.ActionStatusItems = response.data.Values;
      });

    let LookUpUrlActionsComplete =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersActionsComplete = this.$apikeyPost;
    let LookUpRequestActionsComplete = {
      ServiceType: "RemedialActions",
      RequestType: "CompletedActions",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlActionsComplete,
        LookUpRequestActionsComplete,
        LookUpHeadersActionsComplete
      )
      .then((response) => {
        response;
      });
  },

  methods: {
    RequestService(id) {
      // Open up request service thing
      Vue.prototype.$RaisedFrom =
        "Client Service Request from Water Management Services";
      Vue.prototype.$RaisedFromID = id;
      this.$refs["ServiceRequestModal"].show();
    },
    ActionTheAction() {
      this.$refs["ActioningModal"].show();
    },
    DownloadAssessment(id) {
      // this.doPDF = false;

      if (this.AssessmentType == "Water Test Colony") {
        // let SpeedofTest = "";
        // if (this.testingTabs == 0) {
        //   SpeedofTest = "CFUTestDetails";
        // }
        // if (this.testingTabs == 1) {
        //   SpeedofTest = "RapidTestDetails";
        // }
        let LookUpUrlDetails =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersDetails = this.$apikeyPost;
        let LookUpRequestDetails = {
          ServiceType: "WaterTesting",
          RequestType: "CFUTestDetails",
          DataDict: [
            {
              TestID: id,
            },
          ],
        };
        axios
          .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
          .then((response) => {
            this.modalDetails = response.data.Values[0];
            this.ColonyDetails = this.modalDetails;
            this.modalItem = "";
            this.testingTabs = 0;
            this.modalItem = [
              id,
              response.data.Values[0][0],
              response.data.Values[0][1],
              response.data.Values[0][5],
              response.data.Values[0][7],
              response.data.Values[0][8],
            ];
            this.testtype = response.data.Values[0][0];
            if (response.data.Values[0][0] == "Pseudomonas") {
              this.TestPseudo = response.data.Values[7];
            }
            if (response.data.Values[0][0] == "Legionella") {
              this.TestLegion = response.data.Values[0][7];
            }
            this.TestResult = response.data.Values[0][7];
            this.testStatus = response.data.Values[0][8];

            if (this.TestLegion == "Pass") {
              this.LegionColour = "success";
            } else if (this.TestLegion == "Fail") {
              this.LegionColour = "danger";
            } else {
              this.LegionColour = "secondary";
            }

            if (this.TestPseudo == "Pass") {
              this.PseudoColour = "success";
            } else if (this.TestPseudo == "Fail") {
              this.PseudoColour = "danger";
            } else {
              this.PseudoColour = "secondary";
            }

            if (this.TestResult == "Pass") {
              this.OverallColour = "success";
            } else if (this.TestResult == "Fail") {
              this.OverallColour = "danger";
            } else {
              this.OverallColour = "secondary";
            }
            this.$refs["ColonyDetail"].show();
          });
      }
      if (this.AssessmentType == "Water Test Rapid") {
        let LookUpUrlDetails =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersDetails = this.$apikeyPost;
        let LookUpRequestDetails = {
          ServiceType: "WaterTesting",
          RequestType: "RapidTestDetails",
          DataDict: [
            {
              TestID: id,
            },
          ],
        };
        axios
          .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
          .then((response) => {
            this.modalDetails = response.data.Values[0];
            this.ColonyDetails = this.modalDetails;
            this.modalItem = "";
            this.testingTabs = 1;
            this.modalItem = [
              id,
              response.data.Values[0][0],
              response.data.Values[0][1],
              response.data.Values[0][5],
              response.data.Values[0][7],
              response.data.Values[0][8],
            ];
            this.testtype = response.data.Values[0][0];
            if (response.data.Values[0][0] == "Pseudomonas") {
              this.TestPseudo = response.data.Values[7];
            }
            if (response.data.Values[0][0] == "Legionella") {
              this.TestLegion = response.data.Values[0][7];
            }
            this.TestResult = response.data.Values[0][7];
            this.testStatus = response.data.Values[0][8];

            if (this.TestLegion == "Pass") {
              this.LegionColour = "success";
            } else if (this.TestLegion == "Fail") {
              this.LegionColour = "danger";
            } else {
              this.LegionColour = "secondary";
            }

            if (this.TestPseudo == "Pass") {
              this.PseudoColour = "success";
            } else if (this.TestPseudo == "Fail") {
              this.PseudoColour = "danger";
            } else {
              this.PseudoColour = "secondary";
            }

            if (this.TestResult == "Pass") {
              this.OverallColour = "success";
            } else if (this.TestResult == "Fail") {
              this.OverallColour = "danger";
            } else {
              this.OverallColour = "secondary";
            }
            this.$refs["ColonyDetail"].show();
          });
      }
      if (this.AssessmentType == "Risk Assessment") {
        let DetailsLookupURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let DetailsLookupHeaders = this.$apikeyPost;
        let DetailsLookupRequest = {
          ServiceType: "RiskAssessment",
          RequestType: "RiskAssessmentDetails",
          DataDict: [
            {
              AssessmentID: id,
            },
          ],
        };
        axios
          .post(DetailsLookupURL, DetailsLookupRequest, DetailsLookupHeaders)
          .then((response) => {
            let detailsarray = [];
            detailsarray = response.data.Values;
            this.downloadRiskAssess(
              detailsarray[15][0][2],
              detailsarray[0],
              detailsarray[1]
            );
          });
      }
      // Vue.prototype.$PDFType = "RiskAssess";
      // this.componentKey += 1;

      // this.doPDF = true;
    },

    async downloadRiskAssess(id, raid, loc) {
      let filekey = "";
      filekey = loc + "/Risk Assessments/" + raid + "/" + id;
      let attachment = filekey;
      const res = await riskDirectDownloadByKey(attachment);

      axios({
        url: res, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filekey); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
    },

    updateActionStatus() {
      if (this.UpdateStatus != "") {
        let LookUpUrlActionsComplete =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersActionsComplete = this.$apikeyPost;
        let LookUpRequestActionsComplete = {
          ServiceType: "RemedialActions",
          RequestType: "UpdateActionStatus",
          DataDict: [
            {
              ActionID: this.PassActionID,
              Status: this.UpdateStatus,
              CompletionNote: this.CompletionNote,
            },
          ],
        };
        axios
          .post(
            LookUpUrlActionsComplete,
            LookUpRequestActionsComplete,
            LookUpHeadersActionsComplete
          )
          .then((response) => {
            response;
            alert("Action Status Updated");
            this.$refs["ActioningModal"].hide();
            this.$refs["ActionModal"].hide();
            this.resetActionStatus();
            this.resetPage();
          });
      } else {
        alert("Please ensure an updated status is selected");
      }
    },
    resetActionStatus() {
      this.UpdateStatus = "";
    },
    resetPage() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        ServiceType: "RemedialActions",
        RequestType: "CompletedActions",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
        let itemsArray = response.data.Values;
        this.items2 = [];
        for (var i = 0; i < itemsArray.length; i++) {
          this.items2.push({
            ActionID: itemsArray[i][0],
            ActionType: itemsArray[i][1],
            Description: itemsArray[i][2],
            OutletID: itemsArray[i][3],
            CompletedDate: itemsArray[i][4],
            ActionResponsibillity: itemsArray[i][5],
            LinkedRiskAssessment: itemsArray[i][6],
            ActionNote: itemsArray[i][7],
          });
        }
      });

      let LookUpUrlActionCounts =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersActionCounts = this.$apikeyPost;
      let LookUpRequestActionCounts = {
        ServiceType: "RemedialActions",
        RequestType: "ActionCounts",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlActionCounts,
          LookUpRequestActionCounts,
          LookUpHeadersActionCounts
        )
        .then((response) => {
          this.ActionsDue = response.data.ActionsDueThirtyDays;
          this.ActionsNew = response.data.NewActions;
          this.ActionsOverdue = response.data.OverdueActions;
        });

      let LookUpUrlActionStatus =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersActionStatus = this.$apikeyPost;
      let LookUpRequestActionStatus = {
        ServiceType: "RemedialActions",
        RequestType: "ActionStatus",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlActionStatus,
          LookUpRequestActionStatus,
          LookUpHeadersActionStatus
        )
        .then((response) => {
          this.ActionStatusItems = response.data.Values;
        });

      let LookUpUrlActionsComplete =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersActionsComplete = this.$apikeyPost;
      let LookUpRequestActionsComplete = {
        ServiceType: "RemedialActions",
        RequestType: "CompletedActions",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlActionsComplete,
          LookUpRequestActionsComplete,
          LookUpHeadersActionsComplete
        )
        .then((response) => {
          response;
        });
    },
    showActionDetails(item) {
      this.item = item;
      this.ActionStatus = item[7];
      this.PassActionID = item[0];
      this.PassActionType = item[1];
      this.PassDesc = item[2];
      // this.PassOutletID = item[3];
      this.PassLinkAssessment = item[5];
      this.PassActionDeadline = item[3];
      this.PassResponsibility = item[4];
      this.PassNote = item[6];

      this.AssessmentType = "";

      if (this.PassLinkAssessment.slice(0, 2) == "WR") {
        this.AssessmentType = "Water Test Rapid";
      }

      if (this.PassLinkAssessment.slice(0, 2) == "WC") {
        this.AssessmentType = "Water Test Colony";
      }

      if (this.PassLinkAssessment.slice(0, 2) == "RA") {
        this.AssessmentType = "Risk Assessment";
      }

      if (this.ActionStatus == "New") {
        this.ActionVariant = "info";
      } else if (this.ActionStatus == "Overdue") {
        this.ActionVariant = "danger";
      } else if (this.ActionStatus == "Due") {
        this.ActionVariant = "warning";
      } else this.ActionVariant = "secondary";

      this.$refs["ActionModal"].show(
        this.item,
        this.ActionVariant,
        this.PassActionID,
        this.PassActionType,
        this.PassOutletID
      );
    },
  },
  watch: {
    modalShowing() {
      this.doPDF = false;
    },
  },
};
</script>

<style>
.modal {
  text-align: center;
}

.text-red {
  background-color: lightcoral;
}

.text-green {
  background-color: lightgreen;
}

.text-orange {
  background-color: orange;
}

.text-blue {
  background-color: #17a2b8;
}
</style>
